<template>
  <Breadcrumb></Breadcrumb>
  <div class="px-4 sm:px-0" v-if="saleListingAgreement">
    <div class="grid grid-cols-3">
      <div class="col-span-2">
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow m-4">
          <div class="px-4 py-5 sm:p-6">
            <div class="flex gap-2 items-center">
              <div class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
                <BriefcaseIcon class="h-8 w-8 text-gray-700"></BriefcaseIcon>
              </div>
              <SaleListingAgreementId :saleListingAgreement="saleListingAgreement" />
              <div class="p-2">
                <RiskScoringLabel :level="riskScoring?.attributes?.scoreLevel ?? undefined" />
              </div>
              <router-link class="p-2 text-indigo-600 hover:text-indigo-900 ml-auto" :to="{ name: 'edit-sale-listing-agreement', params: { id: saleListingAgreement.id } }">
                {{ $gettext("Editer") }}<span class="sr-only">, {{ saleListingAgreement.id }}</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow m-4">
          <RiskScoringFactorList v-if="riskScoring" :riskScoring="riskScoring" :riskScoringStore="riskScoringStore" @updated="handleRiskScoringUpdate"/>
        </div>
      </div>
      <div class="col-span-1">
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow col-span-1 m-4">
          <div class="px-4 py-5 sm:px-6">
            <span class="text-xl font-semibold text-gray-900">{{ $gettext("Aperçu") }}</span>
          </div>
          <RiskScoringChart v-if="riskScoring" :riskScoring="riskScoring" />
        </div>
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow col-span-1 m-4">
          <div class="px-4 py-5 sm:px-6" v-if="riskScoring">
            <SanctionsBox v-if="riskScoring" :riskScoring="riskScoring" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { ref } from "vue";
import { useSaleListingAgreementStore } from "@/stores/saleListingAgreement.js";
import { useRoute } from "vue-router";
import RiskScoringLabel from "@/components/risk-scorings/RiskScoringLabel.vue";
import RiskScoringFactorList from "@/components/risk-scorings/RiskScoringFactorList.vue";
import { BriefcaseIcon } from "@heroicons/vue/24/outline";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { useRiskScoring } from "@/stores/riskScoring";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import RiskScoringChart from "@/components/risk-scorings/RiskScoringChart.vue";
import SanctionsBox from "@/components/risk-scorings/SanctionsBox.vue";
import SaleListingAgreementId from "@/components/sale-listing-agreements/SaleListingAgreementId.vue"

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

const route = useRoute();
const saleListingAgreementId = route.params.id;
const saleListingAgreementStore = useSaleListingAgreementStore();
const saleListingAgreement = ref(null);

const riskScoringStore = useRiskScoring("sale-listing-agreements", saleListingAgreementId);
const riskScoring = ref(null);

const loadSaleListingsAgreement = async () => {
  saleListingAgreement.value = await saleListingAgreementStore.fetchOne(saleListingAgreementId, null, ["lastRiskScoring"]);
}

const handleRiskScoringUpdate = async () => {
  await loadSaleListingsAgreement();
  let riskScoringId = saleListingAgreement.value.relationships.lastRiskScoring.data.id
  riskScoring.value = await riskScoringStore.fetchOne(riskScoringId);
};

onMounted(async () => {
  await loadSaleListingsAgreement();
  let riskScoringId = saleListingAgreement.value.relationships.lastRiskScoring.data.id
  riskScoring.value = await riskScoringStore.fetchOne(riskScoringId);
});

</script>
